/// <reference path='../../core/contracts/quote.contracts.ts'/>
/// <reference path='../../quote/controllers/quotePublic.controller.ts'/>
/// <reference path='../../core/services/quote.service.ts'/>
/// <reference path='../../core/services/resource.service.ts'/>
/// <reference path="../../../../../../typings/globals/angular/index.d.ts" />
/// <reference path="../../../../../../typings/globals/lodash/index.d.ts" />

namespace ekh {

    class PublicQuoteSummaryController {

        public quoteStatusPromise: ng.IPromise<Quote.QuoteControllerStatus>;
        public quote: Quote.IQuote;
        public trip: Core.Trip.TripState;
        public quoteStatus: Quote.QuoteControllerStatus = Quote.QuoteControllerStatus.Busy;
        public controllerLoaded: boolean = false;
        public hotel: {[key:string]: any};
        public flight: {[key:string]: any};
        public transfer: {[key:string]: any};
        public parking: {[key:string]: any};
        public bookQuote: (position?) => void;
        public clientReadConfirm: boolean = false;
        public detailsStorageConsent: boolean = false;
        public detailsStorageMandatory: boolean = false;
        public priceDifferencePercentage: number;


        constructor(
            private basketService: any,
            private basketStore: any,
            private bookingService: any,
            private dateUtil: any,
            private tripService: Core.TripService,
            private quoteService: Quote.QuoteService,
            private flightDetail: any,
            private $q: ng.IQService,
            private $timeout: ng.ITimeoutService,
            private $rootScope: ng.IRootScopeService,
            private resourceService: Core.ResourceService,
            private $scope: ng.IScope
        ) {
            $rootScope.lockScreen($scope, {
                title: resourceService.get('PREPARINGBOOKING'),
                loadingScreenStyle: 'booking-optionsCtrl'
            });

        }

        $onInit() {
            this.quoteStatusPromise.then((status: Quote.QuoteControllerStatus) => {
                this.$timeout(_ => {
                    this._checkAllProductsRefreshed(status).then((status: Quote.QuoteControllerStatus) => {
                            this.quoteStatus = status;
                            switch (status) {
                                case Quote.QuoteControllerStatus.Ready:
                                    this.$timeout(_ => {
                                        this._init(this.quote);
                                    });
                                    break;
                                default:
                                    this.$rootScope.unlockScreen(this.$scope);
                            }
                    });
                });
            })
            .catch(() => {
                this.quoteStatus = Quote.QuoteControllerStatus.RefreshError;
            });
        }

        private _init(quote) {
            this._setTransfer(quote);
            this._setParking(quote);
            this.$q.all([
                this.basketStore.hotel(quote.BasketId),
                this.basketStore.flight(quote.BasketId)
            ]).then(([hotel, flight]) => {
                this.$rootScope.unlockScreen(this.$scope);
                this.controllerLoaded = true;
                this.flight = flight;
                this.hotel = hotel;
            });
        }

        private _setTransfer(quote) {
            this.transfer = _.find(quote.Products, {TypeId: 2});
        }

        private _setParking(quote) {
            this.parking = _.find(quote.Products, {TypeId: 3});
        }

        private _checkAllProductsRefreshed(status: Quote.QuoteControllerStatus)
            : ng.IPromise<Quote.QuoteControllerStatus> {
            if (!this.trip || !this.quote) {
                return this.$q.when(Quote.QuoteControllerStatus.RefreshError);
            }
            return this.basketStore.getBasket(this.quote.BasketId)
                .then((basket) => {
                    const basketProds = basket.Products.map(p => p.ProductType).sort();
                    const quoteProds = this.quote.Products.map(p => p.TypeId).sort();
                    return _.isEqual(basketProds, quoteProds) ? status : Quote.QuoteControllerStatus.RefreshError;
                });
        }

        public isHFareFlightType() {
            return this.flightDetail.isHFlightType(_.get(this.flight, 'Details.Itinerary'), false);
        };

        public book() {
            this.bookQuote();
        }

        public isBookingDisabled() {
            return !this.clientReadConfirm ||
                (this.detailsStorageMandatory && !this.detailsStorageConsent);
        }

        public quoteIsReady() {
            return this.quoteStatus === Quote.QuoteControllerStatus.Ready;
        }

    }

    angular
        .module('ekh')
        .directive('publicQuoteSummary', function() {
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'partials/home/directivetemplate?type=publicquotesummary',
                controllerAs: 'qps',
                bindToController: {
                    quoteStatusPromise: '=',
                    trip: '=',
                    quote: '=',
                    bookQuote: '&',
                    priceDifferencePercentage: '='
                },
                controller: PublicQuoteSummaryController
            };
        });
}
